import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 17H7A5 5 0 0 1 7 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 7h2a5 5 0 0 1 4 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "12", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Link2Off";
const Link2Off = memo(themed(Icon));
export {
  Link2Off
};
//# sourceMappingURL=link-2-off.js.map
